import { OwnerBlock } from './OwnerBlock'

import React from 'react'

import { BlockWithBorder } from 'components/UI/BlockWithBorder'

import { getName } from 'utils/parsers'

import { CertificateCustomer, Customer } from 'types'

import { Box, Typography, Stack, Divider } from '@mui/material'

interface TransferOwnershipInfoProps {
  certificate: CertificateCustomer
  selectedUser: Customer | null
  transferWaitingConfirmationStatus: boolean
}

export const TransferOwnershipInfo = ({
  certificate,
  selectedUser,
  transferWaitingConfirmationStatus,
}: TransferOwnershipInfoProps) => {
  return (
    <>
      <BlockWithBorder>
        <Stack direction="row" alignItems="center">
          <Box sx={{ width: '60px', height: '60px' }}>
            <img src={certificate.product.images[0]} alt="certImg" width="100%" />
          </Box>
          <Divider
            orientation="vertical"
            flexItem
            sx={theme => ({ margin: '1px 16px', color: theme.palette.grey[400] })}
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'start',
              justifyContent: 'center',
            }}
          >
            <Typography variant="body2">{certificate.product.sku}</Typography>
            <Typography variant="subtitle1" sx={{ lineHeight: '21px' }}>
              {certificate.product.title}
            </Typography>
            <Typography variant="body2">
              <strong style={{ fontWeight: 600 }}>ID: </strong>
              {certificate.id}
            </Typography>
          </Box>
        </Stack>
      </BlockWithBorder>
      <Typography variant="subtitle1" mb="12px" sx={{ lineHeight: '17px' }}>
        Transfer to
      </Typography>
      {(selectedUser || transferWaitingConfirmationStatus) && (
        <Box
          p="4px 0 28px"
          mb={1}
          sx={theme => ({
            /*
             * `!important` is REQUIRED, not defensive: `index.css`'s
             * `#vera-shadow-root *` rule carries ID specificity and discards any
             * `sx` border colour without it, so this rule rendered the app's
             * default grey rather than the tenant's Studio "Border color". See
             * `settings/tokens.ts` for the mechanism.
             */
            borderBottom: `1px solid ${theme.palette.secondary.main} !important`,
          })}
        >
          {selectedUser ? (
            <OwnerBlock
              owner={getName(selectedUser) || selectedUser.email}
              subTitle={selectedUser.email}
              imageUrl={selectedUser.avatar}
            />
          ) : (
            <OwnerBlock
              owner={getName(certificate.transfer.toCustomer) || certificate.transfer.toCustomer.email}
              subTitle={certificate.transfer.toCustomer.email}
              imageUrl={certificate.transfer.toCustomer.avatar}
            />
          )}
        </Box>
      )}
    </>
  )
}
